import { EmptyState } from '@efdigital/ll-xceed-v2/components/application/empty-state';
import { Spinner } from '@efdigital/ll-xceed-v2/components/application/spinner.gts';
import SessionCard from '@efdigital/ll-xceed-v2/components/coaching/coach/session-card.gts';
import type { CoachingCoachSessionsIndexModel } from '@efdigital/ll-xceed-v2/routes/coaching/coach/sessions/index';
import CoachService from '@efdigital/ll-xceed-v2/services/coach';
import { toCoachSessionCardItems } from '@efdigital/ll-xceed-v2/utils/coaching/coach-session-card-items';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { Await } from '@warp-drive/ember';
import { pageTitle } from 'ember-page-title';

interface CoachingCoachSessionsIndexSignature {
  Args: {
    model: CoachingCoachSessionsIndexModel;
    controller: unknown;
  };
}

export default class CoachingCoachSessionsIndex extends Component<CoachingCoachSessionsIndexSignature> {
  @service declare coach: CoachService;
  @service declare router: RouterService;

  refresh = () => {
    this.router.refresh('coaching.coach.sessions.index');
  };

  <template>
    {{pageTitle "Sessions"}}

    {{#if @model.upcoming.length}}
      <Await @promise={{toCoachSessionCardItems @model.upcoming this.coach}}>
        <:success as |sessions|>
          <div class="d-flex flex-column gap-4">
            {{#each sessions as |item|}}
              <SessionCard
                @session={{item.session}}
                @coach={{@model.coach}}
                @coachee={{item.coachee}}
                @coachingConfig={{item.coachingConfig}}
                @onChanged={{this.refresh}}
              />
            {{/each}}
          </div>
        </:success>
        <:pending>
          <Spinner />
        </:pending>
      </Await>
    {{else}}
      <EmptyState @message="You have no upcoming sessions." />
    {{/if}}
  </template>
}
